import {AbstractService} from "./abstract.service";
import {Injectable} from "@angular/core";
import {SupportTicketRepo} from "../repositories/api/support-ticket.repo";
import {Observable, of} from "rxjs";
import {SupportTicketDto} from "../repositories/dto/support-ticket.dto";
import {catchError, map} from "rxjs/operators";
import {SupportWidgetComponent} from "../pages/support/support-widget/support-widget.component";
import {isDefined} from "../libs/utils/epic.utils";
import {VoidDto} from "../repositories/dto/void.dto";

@Injectable({providedIn: 'root'})
export class SupportTicketService extends AbstractService {

  private readonly supportTicketRepo: SupportTicketRepo = this.repoProvider.getRepo(SupportTicketRepo);

  private supportWidgetComponent: SupportWidgetComponent | undefined;

  public registerSupportWidget(component: SupportWidgetComponent): void {
    this.supportWidgetComponent = component;
  }

  public openSupportWidget(): void {
    if (isDefined(this.supportWidgetComponent)) {
      this.supportWidgetComponent.openSupportTicket();
    } else {
      this.log.error('SupportWidgetComponent not registered');
    }
  }

  // Asked before the list and before a new ticket - without Zammad neither makes sense
  public isAvailable(): Observable<boolean> {
    return this.supportTicketRepo.status(this.getOrg())
      .pipe(map((w) => w.getFirstData().available), catchError(() => of(false)));
  }

  public getTicketById(id: string): Observable<SupportTicketDto> {
    return this.supportTicketRepo.getById(this.getOrg(), id)
      .pipe(map((w) => w.getFirstData()));
  }

  public createTicket(ticket: SupportTicketDto, screenshot: Blob | undefined, attachments: File[]): Observable<SupportTicketDto> {
    return this.supportTicketRepo.create(this.getOrg(), ticket, screenshot, attachments)
      .pipe(map((w) => w.getFirstData()));
  }

  public closeTicket(id: string): Observable<VoidDto> {
    return this.supportTicketRepo.close(this.getOrg(), id)
      .pipe(map((w) => w.getFirstData()));
  }

  public replyTicket(id: string, description: string): Observable<SupportTicketDto> {
    const dto = new SupportTicketDto({id, description});
    return this.supportTicketRepo.reply(this.getOrg(), id, dto)
      .pipe(map((w) => w.getFirstData()));
  }
}
